module.exports = __webpack_public_path__ + "static/media/kinkhao_01_full.2582658a.gif";